export default {
  isInitial: true,
  playbackSettings: {
    // baseTime
    // startTime
    // now
    // secondsPerFrame
    // playbackStatus
  },
  isActiveDateInputDialog: false,
  rgPlaybackObjects: [], // Array<action の getAisVesselsHistoryで計算している値>
  layerFilters: {},
  visibleTracks: {
    vessels: [],
  },
};
